import { Box, Button, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Searchbar from '../../../../design/searchbar/Searchbar';
import { useListSearchFilter } from '../context/useListSearchFilter';
import AddIcon from '@mui/icons-material/Add';
import { useEikenMaterialList } from '../hooks/useEikenMaterialList';

export function ListFilter() {
  const { setSearchFilter } = useListSearchFilter();
  const { isLoading } = useEikenMaterialList();
  const navigate = useNavigate();

  return (
    <Box className="flex justify-between mt-8 mb-8">
      <Box className="flex gap-4 flex-grow">
        <Searchbar placeholder="Search for a test" onChange={setSearchFilter} />
        {isLoading && (
          <Box className="flex items-center">
            <CircularProgress size={20} />
          </Box>
        )}
        <Box className="flex-grow"></Box>
        <Button
          variant="contained"
          endIcon={<AddIcon />}
          onClick={() => navigate('/eiken-materials/choose-new')}
        >
          New Test
        </Button>
      </Box>
    </Box>
  );
}
